jQuery(document).ready(function( $ ) {

	$(window).on('opened.zf.offcanvas', function(){
		$('html').addClass('scroll-lock');
});

$(window).on('closed.zf.offcanvas', function(){
	$('html').removeClass('scroll-lock');
});

	$('.featured-slider').slick({
		dots: true,
		responsive: [
	 {
		 breakpoint: 1024,
		 settings: {
			 arrows: false
		 }
	 }
	 // You can unslick at a given breakpoint now by adding:
	 // settings: "unslick"
	 // instead of a settings object
 ]
	});

	$('.milestone-slider').slick({
		slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.milestone-nav-slider',
	centerMode: true,
	responsive: [
		{
			breakpoint: 1024,

			settings: {
				arrows: false,
				centerMode: false,
				adaptiveHeight: true
			}
		}
	],
	});



	$('.milestone-nav-slider').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  asNavFor: '.milestone-slider',
  focusOnSelect: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 1024,

			settings: {
				slidesToShow: 4
			}
		}
	],
});

$(document).on('facetwp-refresh', function() {

	jQuery('.fwpl-term-other').each(function(e){
	if (e != 0) {
	jQuery(this).hide();
	}
	});

	jQuery('.fwpl-term-hollywood-production-center').each(function(e){
if (e != 0) {
jQuery(this).hide();
}
});

jQuery('.fwpl-term-tenten').each(function(e){
if (e != 0) {
jQuery(this).hide();
}
});

jQuery('.fwpl-term-plug-and-play-tech-center').each(function(e){
if (e != 0) {
jQuery(this).hide();
}
});

     });

});
